import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { SITE_NAME } from "../config/AppConfig";
import Header from "./../component/Header";
import Footer from "./../component/Footer";
import { API_BASE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";

const carouselImg = require("./../assets/img/shop-creation-img.svg").default;

const ShopCreation = props => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { selectedLanguage, langJson } = useLanguage();
  const [allDetails, setAllDetails] = useState();

  const fetchConfigDetails = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}frontend/configs`, {
        method: "GET",
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setAllDetails(responseData.data);
      } else {
      }
    } catch (error) { }
  };

  useEffect(() => {
    if (user?.role !== "admin") {
      fetchConfigDetails();
    }
  }, []);

  const handleLoginClick = (e) => {
    e.preventDefault();
    const loginPopup = document.querySelector(".loginPopup");
    if (loginPopup) {
      loginPopup.classList.add("active");
    }
  };

  return (
    <div>
      <Header />
      <div className="shopCreationDiv">
        <div className="mainDiv">
          <div className="topDiv">
            <h2>{langJson?.millionsofpeoplearoundtheworldcantwaittovisityourshop}.</h2>
            <p>
              {langJson?.letsgetstartedto} {SITE_NAME} {langJson?.shopaccount}
            </p>
            <img src={carouselImg} alt="" />
            <h3>
              {langJson?.openan} {SITE_NAME} {langJson?.shopandmaintainyourownshop}!
            </h3>
            <div style={{ display: "flex", gap: "15px", justifyContent: "center", flexWrap: "wrap" }}>
              <Link to="/vendor-register">{langJson?.register}</Link>

            </div>
            <p>
              {langJson?.alreadyon} {SITE_NAME}? <span onClick={handleLoginClick} style={{ textDecoration: "underline", cursor: "pointer" }}>
                {langJson?.login}
              </span>
            </p>


          </div>
          <div className="innrSec shopCreaInner">
            <div className="leftInner">
              <h2>{langJson?.whats} {SITE_NAME}?</h2>
              <p>{allDetails?.find(item => item.name === "register-about")?.value}</p>
            </div>
            <div className="rightInner">
              <h2>{langJson?.howmuchdoesitcosttosell}?</h2>
              <p>{allDetails?.find(item => item.name === "register-cost")?.value}</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ShopCreation;
